import { Inbox, type LucideIcon } from 'lucide-react';

export function EmptyState({ title, description, icon: Icon = Inbox }: { title: string; description?: string; icon?: LucideIcon }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-14 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full border border-surface-600 bg-surface-900 text-accent-400">
        <Icon className="h-5 w-5" strokeWidth={1.5} />
      </span>
      <p className="text-sm font-medium text-ivory-300">{title}</p>
      {description && <p className="text-xs text-ivory-500">{description}</p>}
    </div>
  );
}
